import React from 'react';
import {defaultAlert} from "../../utils/alert";


interface SearchDateSelectProps {
    startDate: string;
    endDate: string;
    onStartDateChange: (date: string) => void;
    onEndDateChange: (date: string) => void;
    maxMonths?: number;
}

const SearchDateSelect = ({
                              startDate,
                              endDate,
                              onStartDateChange,
                              onEndDateChange,
                              maxMonths = 3
                          }: SearchDateSelectProps) => {

    const isOverMaxMonths = (start: string, end: string, maxMonths: number) => {
        const s = new Date(start);
        const e = new Date(end);

        const months =
            (e.getFullYear() - s.getFullYear()) * 12 +
            (e.getMonth() - s.getMonth());

        return months > maxMonths;
    };

    const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newStartDate = e.target.value;

        if (endDate && isOverMaxMonths(newStartDate, endDate, maxMonths)) {
            defaultAlert(`최대 ${maxMonths}개월까지만 조회 가능합니다.`);
            return;
        }

        onStartDateChange(newStartDate);
    };

    const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newEndDate = e.target.value;

        if (startDate && isOverMaxMonths(startDate, newEndDate, maxMonths)) {
            defaultAlert(`최대 ${maxMonths}개월까지만 조회 가능합니다.`);
            return;
        }

        onEndDateChange(newEndDate);
    };

    const today = new Date().toISOString().split('T')[0];
    const minEndDate = startDate || undefined;

    const getMaxEndDate = () => {
        if (!startDate) return today;

        const start = new Date(startDate);
        const maxDate = new Date(start);
        maxDate.setMonth(maxDate.getMonth() + maxMonths);

        const todayDate = new Date(today);
        return maxDate > todayDate
            ? today
            : maxDate.toISOString().split('T')[0];
    };

    return (
        <div className="form-item mt10">
            <div className="search-date-box">
                <div className="date-input">
                    <input
                        type="date"
                        value={startDate}
                        max={today}
                        onChange={handleStartDateChange}
                    />
                </div>
                <p>~</p>
                <div className="date-input">
                    <input
                        type="date"
                        value={endDate}
                        min={minEndDate}
                        max={getMaxEndDate()}
                        onChange={handleEndDateChange}
                    />
                </div>
            </div>
        </div>
    );
};


export default SearchDateSelect;